import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getCSAProductList,getSerialNoDetails, sendCsaProductSearchValue } from "../../actions/csaApp";
import { withRouter } from 'react-router-dom';
import React, { useEffect, useRef, useState } from "react";
import { BrowserMultiFormatReader } from "@zxing/library";



const ProductScanner = (props) => {

  const videoRef = useRef(null);
  const [scannedBarcode, setScannedBarcode] = useState("");
  const [isScanning, setIsScanning] = useState(true);
  const codeReaderRef = useRef(new BrowserMultiFormatReader());
  const barcodeOrSerialNo = localStorage.getItem('barcodeOrSerialNo')


  useEffect(() => {
    let codeReader = codeReaderRef.current;
    let selectedDeviceId = null;

    if (!isScanning) return;

    const startScanning = async () => {
      try {
        stopCamera();
    
        // Get available video devices
        const devices = await navigator.mediaDevices.enumerateDevices();
        const videoDevices = devices.filter(function(device) {
          return device.kind === "videoinput";
        });
    
        if (videoDevices.length === 0) {
          alert("No camera found.");
          return;
        }
    
        // Select the back camera if available, otherwise use the first device
        let selectedDeviceId = null;
        for (let i = 0; i < videoDevices.length; i++) {
          if (videoDevices[i].label.toLowerCase().includes("back")) {
            selectedDeviceId = videoDevices[i].deviceId;
            break;
          }
        }
    
        // If no back camera is found, default to the first available video device
        if (selectedDeviceId === null) {
          selectedDeviceId = videoDevices[0].deviceId;
        }
    
        // Start the video stream with specified settings
        const stream = await navigator.mediaDevices.getUserMedia({
          video: {
            deviceId: { exact: selectedDeviceId },
            facingMode: { ideal: "environment" },
            width: { ideal: 1920 },
            height: { ideal: 1080 },
            frameRate: { ideal: 30 },
            advanced: [
              { focusMode: "continuous" },
            ],
          },
        });

    
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
    
        // Start decoding the barcode
        codeReader.decodeFromVideoDevice(selectedDeviceId, videoRef.current, function(result, err) {
          if (result) {
            setScannedBarcode(result.text);
            stopCamera(); // Stop the camera after scanning
            setIsScanning(false);
            handleScanner(result.text);
          }
        });
      } catch (err) {
        console.error("Error starting camera:", err);
        alert("Error starting the camera: " + err.message);
      }
    };
    

    startScanning();

    return () => {
      stopCamera();
      codeReader.reset();
    };
  }, [isScanning]);

  const stopCamera = () => {
    if (videoRef.current && videoRef.current.srcObject) {
      const stream = videoRef.current.srcObject;
      stream.getTracks().forEach((track) => track.stop());
      videoRef.current.srcObject = null;
    }
    codeReaderRef.current.reset();
  };

    const handleScanner = async(d1='') => {
    //  if(DataTransferItem !== null) {
        const { connection_id,getCSAProductList,getSerialNoDetails,history,sendCsaProductSearchValue ,web_session_trans_id} = props;
        const storeFlag = localStorage.getItem('csa_storeFlag');
        const barcodeOrSerialNo = localStorage.getItem('barcodeOrSerialNo')


    let options = {
            "connection_id": connection_id,
            "product_id": null,
            "sku_id":null,
            "barcode":d1 ,
            "store_flag":storeFlag,
            "size_id":  [],
            "color_id":  [],
            "brand_code":[],
            "category_id":[],
            "gender_id":[
               
            ],
           
            "new_arrivals":"",
            "price_start_range":0,
            "price_end_range":9999999,
            
           "page":""
            }
               let data = {
        connection_id : connection_id,
        web_session_id : web_session_trans_id,
        qty:'1',
        ean:this.state.bar_code,
        RID_CART_ORDER_TYPE :   '',
        ORDER_SUB_TYPE :  '',
         RID_LOT_CD :"",
             RID_FREE_ITEM : "N",
             SCAN_TYPE :"",
             RID_RFID_TAG_SLNO :"",
             RID_SALES_MAN_CODE :"",
             RID_PROCEED_WITH_EAN : "N",
             RID_PROCEED_WITH_GLOBAL_ORDER : null,
             PICKUP_LOC_TYPE :null


      }
         localStorage.setItem('optionValue',JSON.stringify(options))

        // let options = {
        //     "connection_id": connection_id,
        //     "product_id": '',
        //     "sku_id":'',
        //     "barcode":data,
        //     "store_flag":'AL',
        //     "size_id":  [],
        //     "color_id":  []
        //     }
        barcodeOrSerialNo == "B" ? 
              await  getCSAProductList(options) :  await getSerialNoDetails(data)
    
            history.push('/csa-products')
        //  }
    }

    return(
        <React.Fragment>
                <div className="csa-product-search">
                    <div className="container">
                    <div className="container-tab mx-auto">
                        <div class="row" style={{paddingBottom:40}}>
                            <div class="col-md-8 mx-auto">

                            <div className="row" style={{ paddingBottom: 10}} >
                                <div className="col-sm-12 text-center">
                                    <p></p>
                                    <div className="mini-title scan-text">
                                     { barcodeOrSerialNo == 'B' ? 
                                        <span className="mx-auto">Scan Barcode</span> :
                                        <span className="mx-auto">Scan SerialNo</span> } 
                                    </div>
                                </div>
                            </div>
                            {/* <div className="row" style={{paddingBottom:10,textAlign:'center'}}>
                              <div className="col-6">
                                <button className="btn btn-solid" style={{    padding: "2px 16px"}} onClick={()=>{}}>
                                  Reset
                                </button>
                              </div>
                              <div className="col-6">
                                <button className="btn btn-solid" style={{    padding: "2px 16px"}} onClick={()=>{}}>
                                  Back
                                </button>
                              </div>
                            </div> */}
                                {/* { data === 'Not Found' ? */}
                                {
                                isScanning ? 
                                (
 <div style={{ position: "relative", width: "100%", height: "0", paddingBottom: "80%" }}>
 {/* Video Stream */}
 <video
   ref={videoRef}
   style={{
     position: "absolute",
     top: 0,
     left: 0,
     width: "100%",
     height: "100%",
     objectFit: "cover", // Ensures the video fills the container without distortion
   }}
   autoPlay
   playsInline
 />

 {/* Visual Alignment Box */}
 <div
   style={{
     position: "absolute",
     top: "50%",
     left: "50%",
     transform: "translate(-50%, -50%)",
     width: "60%",  
     height: "20%", 
     maxWidth: "300px", 
     maxHeight: "100px", 
     border: "2px solid red",
     boxSizing: "border-box",
     pointerEvents: "none",
   }}
 ></div>
</div>
) : (<div className="row">
  <div className="col-12" style={{textAlign:'center'}}>{props.filterLoader}</div></div>)}

                                {/* :
                                <>
                                <p style={{textAlign:'center'}}>{data}</p>
                                <div className="size-box" style={{ padding: '20px 0px'}}>
                                    <div className="row">
                                        <div className="col-md-2 col-sm-2   col-xs-2 mx-auto">
                                                <button className="btn btn-solid csa-product-btn" type="submit" onClick={() =>handleScanner()} style={{padding: '6px 16px'}}>Go</button>
                                        </div>
                                    </div>
                                </div>
                                </>
                                } */}

                               
                            </div>
                        </div>
                    </div>
                    </div>
                </div>

            </React.Fragment>
    )
}

const mapStateToProps = (state, ownProps) => ({
    OFN_enabled: state.tenant.OFN_enabled,
    connection_id: state.tenant.connection_id,
    success: state.csa.success,
    filterLoader : state.csa.loading,
    web_session_trans_id: state.user.user_details && state.user.web_session_trans_id,

});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { getCSAProductList, sendCsaProductSearchValue,getSerialNoDetails },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ProductScanner));